var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { clearable: "", placeholder: "请输入优惠券名称" },
            model: {
              value: _vm.listQuery.name,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "name", $$v)
              },
              expression: "listQuery.name",
            },
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: { clearable: "", placeholder: "请选择优惠券状态" },
              model: {
                value: _vm.listQuery.status,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "status", $$v)
                },
                expression: "listQuery.status",
              },
            },
            _vm._l(_vm.statusOptions, function (type) {
              return _c("el-option", {
                key: type.value,
                attrs: { label: type.label, value: type.value },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["GET /admin/coupon/list"],
                  expression: "['GET /admin/coupon/list']",
                },
              ],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v("查找")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-download" },
              on: { click: _vm.onCancel },
            },
            [_vm._v("清空")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["POST /admin/coupon/create"],
                  expression: "['POST /admin/coupon/create']",
                },
              ],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-edit" },
              on: { click: _vm.handleCreate },
            },
            [_vm._v("添加")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: {
                loading: _vm.downloadLoading,
                type: "primary",
                icon: "el-icon-download",
              },
              on: { click: _vm.handleDownload },
            },
            [_vm._v("导出")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            height: "650",
            data: _vm.list,
            "element-loading-text": "正在查询中。。。",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "",
              width: "100",
              label: "优惠券ID",
              prop: "id",
              sortable: "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "",
              width: "100",
              label: "优惠券名称",
              prop: "name",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "",
              width: "100",
              label: "作用站点",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.siteType == 0
                      ? _c("span", [_vm._v("国内站")])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.siteType == 1
                      ? _c("span", [_vm._v("海外站")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "160",
              label: "介绍",
              prop: "desc",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", width: "80", label: "标签", prop: "tag" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "优惠", width: "200px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.policy == 0
                      ? _c("span", [
                          _vm._v(
                            "百分比优惠—" + _vm._s(scope.row.amount) + "%"
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.policy == 1
                      ? _c("span", [
                          _vm._v(
                            "固定优惠—" +
                              _vm._s(scope.row.amount) +
                              _vm._s(scope.row.siteType == 0 ? "元" : "美元")
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "100",
              label: "商品使用范围",
              prop: "goodsType",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("formatGoodsType")(scope.row.goodsType))
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "80",
              label: "优惠券类型",
              prop: "type",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm._f("formatType")(scope.row.type)))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "80",
              label: "优惠券数量",
              prop: "total",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(scope.row.total != 0 ? scope.row.total : "不限")
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "80",
              label: "剩余优惠券数量",
              prop: "restCount",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        scope.row.total != 0 ? scope.row.restCount : "不限"
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "160",
              label: "生成时间",
              prop: "addTime",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.row.addTime))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "160",
              label: "生效时间",
              prop: "effectTime",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.row.effectTime))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "160",
              label: "到期时间",
              prop: "invalidTime",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.timeType == 0
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.days == 0 ? "——" : scope.row.invalidTime
                            )
                          ),
                        ])
                      : _c("span", [_vm._v(_vm._s(scope.row.invalidTime))]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "80",
              label: "状态",
              prop: "status",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatStatus")(scope.row.status))),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              label: "操作",
              width: "300",
              "class-name": "small-padding fixed-width",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["GET /admin/coupon/read"],
                            expression: "['GET /admin/coupon/read']",
                          },
                        ],
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/coupon/update"],
                            expression: "['POST /admin/coupon/update']",
                          },
                        ],
                        attrs: {
                          disabled: _vm.disabledStates[scope.$index],
                          type: "info",
                          size: "mini",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleUpdate(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/coupon/delete"],
                            expression: "['POST /admin/coupon/delete']",
                          },
                        ],
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total>0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.textMap[_vm.dialogStatus],
            visible: _vm.dialogFormVisible,
            width: "865px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticStyle: { width: "400px", "margin-left": "50px" },
              attrs: {
                rules: _vm.rules,
                model: _vm.dataForm,
                "status-icon": "",
                "label-position": "left",
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "优惠券名称", prop: "name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.dataForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "name", $$v)
                      },
                      expression: "dataForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "券码", prop: "code" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入券码，或点击确定后自动生成" },
                    model: {
                      value: _vm.dataForm.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "code", $$v)
                      },
                      expression: "dataForm.code",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        position: "absolute",
                        width: "max-content",
                        "margin-left": "20px",
                      },
                    },
                    [_vm._v("支持数字、英文字母、字符、长度8位")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "作用站点", required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.dataForm.siteType,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "siteType", $$v)
                        },
                        expression: "dataForm.siteType",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: 0 } }, [
                        _vm._v("国内站"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: 1 } }, [
                        _vm._v("海外站"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "介绍", prop: "desc" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.dataForm.desc,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "desc", $$v)
                      },
                      expression: "dataForm.desc",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "标签", prop: "tag" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.dataForm.tag,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "tag", $$v)
                      },
                      expression: "dataForm.tag",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "优惠策略", required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.dataForm.policy,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "policy", $$v)
                        },
                        expression: "dataForm.policy",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: 0 } }, [
                        _vm._v("百分比优惠"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: 1 } }, [
                        _vm._v("固定优惠"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "amount" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, "controls-position": "right" },
                    model: {
                      value: _vm.dataForm.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "amount", $$v)
                      },
                      expression: "dataForm.amount",
                    },
                  }),
                  _vm._v(" "),
                  _vm.dataForm.siteType == 0 && _vm.dataForm.policy == 1
                    ? _c("span", [_vm._v("元")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataForm.siteType == 1 && _vm.dataForm.policy == 1
                    ? _c("span", [_vm._v("美元")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataForm.policy == 0
                    ? _c("span", [_vm._v("%")])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "分发类型", prop: "type" } },
                [_c("span", [_vm._v("兑换码")])]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "优惠券数量", prop: "total" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, "controls-position": "right" },
                    on: { change: _vm.changeNum },
                    model: {
                      value: _vm.dataForm.total,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "total", $$v)
                      },
                      expression: "dataForm.total",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("张")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        position: "absolute",
                        width: "max-content",
                        "margin-left": "20px",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          "剩余优惠券数量：" +
                            (_vm.dataForm.total != 0
                              ? _vm.dataForm.restCount
                                ? _vm.dataForm.restCount
                                : _vm.dataForm.total + " 张"
                              : "不限")
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "有效期" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.dataForm.timeType,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "timeType", $$v)
                        },
                        expression: "dataForm.timeType",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: 0 } }, [
                        _vm._v("领券相对天数"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: 1 } }, [
                        _vm._v("指定绝对时间"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        position: "absolute",
                        width: "max-content",
                        "margin-left": "20px",
                      },
                    },
                    [
                      _vm._v(
                        "备注：领券相对时间设置为0天，则该优惠券有效期为无限期"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.dataForm.timeType === 0,
                      expression: "dataForm.timeType === 0",
                    },
                  ],
                },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, "controls-position": "right" },
                    model: {
                      value: _vm.dataForm.days,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "days", $$v)
                      },
                      expression: "dataForm.days",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("天")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.dataForm.timeType === 1,
                      expression: "dataForm.timeType === 1",
                    },
                  ],
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "选择日期",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "picker-options": _vm.pickerOptions,
                        },
                        on: { change: _vm.changeStartTime },
                        model: {
                          value: _vm.dataForm.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "startTime", $$v)
                          },
                          expression: "dataForm.startTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { staticClass: "line", attrs: { span: 2 } }, [
                    _vm._v("至"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "选择日期",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "picker-options": _vm.pickerOptions2,
                        },
                        on: { change: _vm.changeendTime },
                        model: {
                          value: _vm.dataForm.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "endTime", $$v)
                          },
                          expression: "dataForm.endTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "订单限制范围" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.dataForm.goodsType,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "goodsType", $$v)
                        },
                        expression: "dataForm.goodsType",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: 0 } }, [
                        _vm._v("会员支付订单"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: 1 } }, [
                        _vm._v("商品订单"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.dataForm.goodsType === 1,
                      expression: "dataForm.goodsType === 1",
                    },
                  ],
                },
                [_vm._v("\n        目前不支持\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.dialogStatus == "create"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createData },
                    },
                    [_vm._v("确定")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.updateData },
                    },
                    [_vm._v("确定")]
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "couponDialog",
          attrs: { visible: _vm.viewVisible, width: "349px" },
          on: {
            "update:visible": function ($event) {
              _vm.viewVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("div", { staticClass: "title" }, [_vm._v("优惠券兑换码")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.couponCode))]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { width: "300px" },
                  attrs: { type: "primary", round: "" },
                  on: { click: _vm.onCopyCode },
                },
                [_vm._v("复制使用")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }